import React, { Component } from 'react';
import {
    prettifyCardNumber
} from '../../../utils/string';
import { depositShape } from '../../../utils/propTypes';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { currencyMapper } from '@nexio/emvio-util-app';
import { prettifyDate } from '../../../utils/string';
import { get } from 'lodash';
import './DepositSummaryListItem.scss';

export default class DepositSummaryListItem extends Component {
    static propTypes = {
        item: depositShape.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderMerchant(merchantName) {
        return merchantName ? merchantName : 'No Merchant';
    }

    renderDda(dda) {
        return dda ? prettifyCardNumber(dda) : 'No DDA';
    }

    render() {
        const depositSummary = this.props.item;
        const currencyCode = get(currencyMapper, depositSummary.currencyId, '840').code;

        return (
            <div className="deposit-summary-list-item">
                <div className="deposit-summary-list-item-left">
                    <span className="deposit-summary-date">
                        {this.renderDate(depositSummary.date)}
                    </span>
                    <span className="deposit-summary-merchant">
                        {this.renderMerchant(depositSummary.merchantName)}
                    </span>
                </div>
                <div className="deposit-summary-list-item-right">
                    <span className="deposit-summary-amount">
                        <ColorDollarAmountCell amount={depositSummary.amount} currencyCode={currencyCode}/>
                    </span>
                    <span className="deposit-summary-dda">
                        {this.renderDda(depositSummary.dda)}
                    </span>
                </div>
            </div>
        );
    }
}
